//services
import API from 'services/api';

// Profile
export const getProfileInfo = () => API.get('/api/profile');
export const getDashboardInfo = () => API.get('/api/profile/dashboard');

export const getProfileDetails = () => API.get('/api/profile/details');
export const updateProfileDetails = ({ payload }) => API.put(`/api/profile/details`, payload);
export const updatePassword = ({ payload }) => API.put(`/api/profile/password-change`, payload);

export const getInvoice = () => API.get('/api/profile/invoice');
export const updateInvoice = ({ payload }) => API.put(`/api/profile/invoice`, payload);

export const getCompanyDetails = () => API.get('/api/profile/company');
export const updateCompanyDetails = ({ payload }) =>
  API.put(`/api/profile/company`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data;',
    },
  });

export const getProfilePackages = () => API.get('/api/profile/packages');
export const getProfilePackagePricelist = packageId =>
  API.get(`/api/profile/packages/${packageId}/pricelist`);

export const getProfilePackageSubscription = () => API.get('/api/profile/packages/subscription');
export const updateProfilePackageSubscription = ({ payload, packageId }) =>
  API.put(`/api/profile/packages/${packageId}/subscription`, payload);

export const getCustomerSettings = () => API.get('/api/customers/settings');
export const updateCustomerSettings = ({ payload }) => API.put(`/api/customers/settings`, payload);

export const getLanguages = () => API.get('/api/languages/all');

//Contract
export const getContractPaymentModels = () => API.get('/api/payment-models');
export const createContractPaymentModels = ({ payload }) =>
  API.post('/api/payment-models', payload);
export const getContractPaymentModel = paymentModelId =>
  API.get(`/api/payment-models/${paymentModelId}`);
export const updateContractPaymentModels = ({ payload, paymentModelId }) =>
  API.put(`/api/payment-models/${paymentModelId}`, payload);

//Contract -> cooperation-types
export const getContractCooperationTypes = () => API.get('/api/cooperation-types');
export const createContractCooperationTypes = ({ payload }) =>
  API.post('/api/cooperation-types', payload);
export const updateContractCooperationType = ({ payload, cooperationTypeId }) =>
  API.put(`/api/cooperation-types/${cooperationTypeId}`, payload);

//Contract -> cancellation expenses
export const getContractCancellationExpenses = () => API.get('/api/cancellation-expenses');
export const createContractCancellationExpenses = ({ payload }) =>
  API.post('/api/cancellation-expenses', payload);
export const updateContractCancellationExpenses = ({ payload, cancellationExpensesId }) =>
  API.put(`/api/cancellation-expenses/${cancellationExpensesId}`, payload);
